import React, { Component } from 'react';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import FlatButton from 'material-ui/FlatButton';
import UserSelectField from './UserSelectField';

export default class CompanyActionsToolbar extends Component {

  props = {
    selectedCompanies: [],
    onTargetSellerSelected: undefined,
    selectedSeller: undefined
  }

  render() {
    var length = this.props.selectedCompanies.length;
    var countString = length > 1 ? length+" yritystä valittu. ->" : "Yksi yritys valittu. ->";
    return <Toolbar style={{backgroundColor: 'white', borderTop: '3px orange solid', position:'fixed', bottom: 0, left: 0, right: 0}}>
      <ToolbarGroup>
        <p>{countString}</p>
        <UserSelectField
          style={{paddingTop: 0, marginTop: 0, marginLeft:'20px'}}
          hintText="Valitse myyjä"
          emptyText="Valitse myyjä"
          onUserSelected={(user) => this.props.onTargetSellerSelected(user)}
          value={this.props.selectedSeller ? this.props.selectedSeller._id : null} />
        <FlatButton label="Aseta myyjä" disabled={!this.props.selectedSeller || this.props.selectedSeller == null} primary={true} onTouchTap={() => this.props.onAssignSeller() }/>
      </ToolbarGroup>
    </Toolbar>;
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/CompanyActionsToolbar.js